import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import AnnouncementBar from './src/components/AnnouncementBar';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'announcement-bar',
        component: AnnouncementBar,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
